import React            from 'react';
import ErrorBoundary    from '../../../../../common/utils/error-boundary';

export const MainDisplay = props => {
    return (
        <div className="dashboard-content-main-display">
            <ErrorBoundary>
                { props.children }
            </ErrorBoundary>
        </div>
    );
}
 
export default MainDisplay;